import { render, staticRenderFns } from "./ListIdeas.vue?vue&type=template&id=5d0f7b26&"
import script from "./ListIdeas.vue?vue&type=script&lang=js&"
export * from "./ListIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports